/* globals WineryMap, jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'magnific-popup'


import debounce from './debounce.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'


(($) => {

  $.fn.responsiveNav = responsiveNav
  $.fn.accordion = accordion

  //main hero slideshow
  $('.hero-slideshow.flexslider').flexslider({
      controlNav: false,
      directionNav: false,
      touch: false,
      pauseOnAction: false
  })

  // Make nav menu nice & responsive
  $('nav.main-nav').responsiveNav({
    navType: 'dropdown',
    closeOnOutsideClick: false
  })

  // Responsive Videos
  $('.rtecontent, .video_embed').fitVids()

  // Accordions
  $('dl.accordion').accordion()

  $('.area-toggle').on('click',function(){
      $(this).parent().toggleClass('toggle');
      $(this).parent().next().slideToggle();
  });

  $(window).resize( $.debounce(function() {
      if( $(window).width > 819 ){
          $('.area-toggle').parent().removeClass('toggle');
          $('.area-toggle').parent().next().removeAttr('style');
      }
  },250));

  //Handling back links with hashtags
  $('.btn--back').each(function(){
    if (window.location.hash) {
        $(this).attr('href', $(this).attr('href') +  window.location.hash);
    }
  });

  //WWANDER DOWNLOAD POPUP
  $('.js-download-popup').magnificPopup({
      type:'inline',
      callbacks: {
        open: function() {
            //get the file id for this tour guide
            var formId = this.currItem.el.data('fileid');
            var formName = this.currItem.el.data('filename');
            var fileElement = $('.wwander-form-id');
            fileElement.find('input').val(formId);

            var fileNameElement = $('.wwander-form-name');
            fileNameElement.find('input').val(formName);
        },
        close: function(e) {
            var gwrf = window.gwrf_8;
			if( typeof gwrf != 'undefined' ) {
                $('#wander-confirmation').remove();
				gwrf.reloadForm();
			}
        },
      },
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });


  //Winery Map
  var mapElement = document.getElementById('location-map');
  var filterFormElement = document.getElementById('location-map-filter-form');
  var listElement = document.getElementById('location-list');

	if (mapElement && filterFormElement) {
    //console.log(WineryMap);
    var WineryMapClass = require('./winerymap.js');
		var wineryMap = new WineryMapClass(mapElement, filterFormElement, listElement);
		wineryMap.initMap();

        //function to toggle between list view and map view
        const toggleWineryView = function( hash ){
            if( hash == '#map' ){
                $('#location-list').hide();
                $('#location-map').show();
            }
            else{
                $('#location-list').show();
                $('#location-map').hide();
            }
            window.location.hash = hash
        }

        const hashtag = window.location.hash;
        const sectionId = '#location-'+hashtag.replace('#','');
        //on page load check the hashtag and that the section exists
        if( hashtag && $(sectionId).length > 0 ){
            //toggle to the correct view
            toggleWineryView(hashtag);
            //set proper toggle active
            $('.filter-bar__toggles .toggle').removeClass('active');
            $('.filter-bar__toggles .toggle[href="'+ hashtag +'"]').addClass('active');
        }

        const urlParams = new URLSearchParams(location.search);
        if (urlParams) {
            for (const [key, value] of urlParams) {
                if (key == 'varietal') {
                    $("#offering-types option").filter(function() {
                        return $(this).text() == value;
                    }).prop('selected', true);
                }
                if (key == 'region') {
                    $("#location-region option").filter(function() {
                        return $(this).text() == value;
                    }).prop('selected', true);
                }
            }
        }

        //on view toggle click
        $('.filter-bar__toggles .toggle').on('click',function(e){
            e.preventDefault();
            const this_hash = $(this).attr('href');

            //toggle to the correct view
            toggleWineryView(this_hash);
            //set proper toggle active
            $(this).parent().children().removeClass('active');
            $(this).addClass('active');
        });


  }

  //Winery List
$(document).on('click', '.loc-link, .loc-link-card', function(evnt){
    var $originatingTarget = $(evnt.target);
    if ($originatingTarget && $originatingTarget.is('.loc-link-reservation')) {
        evnt.stopPropagation();
    } else {
        window.location.href = $(this).data('link');
    }
  });

// Clear filters button
$('#clear-filters').on('click',function(){ location.reload(); });

// Show More/Less Buttons
$('.show-more-btn').on('click', function() {
    var group = this.parentNode;
    var hidden = group.querySelectorAll('.hidden-filter-group');
    hidden.forEach(function(el){ el.style.display = 'block'; });
    this.style.display = 'none';
    group.querySelector('.show-less-btn').style.display = 'inline-block';
});
$('.show-less-btn').on('click', function() {
    var group = this.parentNode;
    var hidden = group.querySelectorAll('.hidden-filter-group');
    hidden.forEach(function(el){ el.style.display = 'none'; });
    this.style.display = 'none';
    group.querySelector('.show-more-btn').style.display = 'inline-block';
    group.scrollIntoView({behavior: 'smooth', block: 'start'});
});

    //Event List
    $('#event-search-filter').on('click',function(){
        var found=0;
        var filter = $('#event-search-term').val().toLowerCase();
        if (filter.length > 0) {
            var found=0;
            $('.event-list--footer').hide();
            $('#event-list-notice').removeClass('hidden');
            $('#events-list').find('li').each(function(){
                if ($(this).find('.event-list--name').html().toLowerCase().indexOf(filter) >= 0 ||
                    $(this).find('.event-list--description').html().toLowerCase().indexOf(filter) >= 0) {
                    $(this).show();
                    $('#event-list-notice').addClass('hidden');
                } else {
                    $(this).hide();
                }
            });
        } else {
            $('#events-list').find('li').show();
            $('#event-list-notice').addClass('hidden');
        }
        
    });
    $('#event-search-clear').on('click',function(){
        location.reload();
    });
})(jQuery)
